(() => {
  // Solo en producto "personalizado"
  const isPersonalizado =
    document.documentElement.classList.contains("template-product") &&
    (window.location.pathname.includes("/products/") || window.location.pathname.includes("/product/")) &&
    document.body.innerText; // dummy para evitar lints

  // Shopify usa template.suffix en liquid; aquí lo aseguramos por URL (tu caso /products/personalizar)
  if (!location.pathname.includes("/products/")) return;

  // Crea el contenedor flotante
  const box = document.createElement("div");
  box.id = "fh-floating-preview";
  const img = document.createElement("img");
  img.alt = "Preview";
  box.appendChild(img);
  document.body.appendChild(box);

  // Busca la imagen principal (mismo estilo que tu image-swap)
  function getMainImgEl() {
    const selectors = [
      ".media-gallery .is-active img",
      ".media-gallery__viewer img",
      ".product__media-item.is-active img",
      ".product__media-wrapper img",
      ".product__media-list img",
      ".product__media img",
      ".product-gallery img",
      ".product__media img",
      "main img"
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && (el.currentSrc || el.src)) return el;
    }
    return null;
  }

  function syncFromMain() {
    const main = getMainImgEl();
    if (!main) return;

    const src = main.currentSrc || main.src;
    if (!src) return;

    if (img.src !== src) img.src = src;
  }

  function setVisible(v) {
    box.style.display = v ? "block" : "none";
  }

  // 1) Mantén sincronizado el src cuando tu image-swap cambie la imagen
  //    (observamos cambios en el DOM y en atributos)
  const mo = new MutationObserver(() => {
    syncFromMain();
  });
  mo.observe(document.body, { subtree: true, childList: true, attributes: true });

  // 2) Mostrar/ocultar cuando la imagen principal sale/entra a viewport
  function bindIntersection() {
    const main = getMainImgEl();
    if (!main) return false;

    // Si el navegador soporta IntersectionObserver:
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          // Si la imagen principal NO está visible, mostramos el preview
          setVisible(!entry.isIntersecting);
        },
        {
          root: null,
          threshold: 0.15,
        }
      );
      io.observe(main);
      return true;
    }

    // Fallback simple: siempre visible al scrollear un poco
    window.addEventListener("scroll", () => {
      setVisible(window.scrollY > 300);
    });
    return true;
  }

  // Inicial
  syncFromMain();

  // Espera a que Shopify/PC Product Options termine de renderizar
  let tries = 0;
  const t = setInterval(() => {
    tries += 1;
    syncFromMain();
    if (bindIntersection() || tries > 30) clearInterval(t);
  }, 250);

  // También sincroniza cuando cambian inputs (por si tu app no muta attributes)
  document.addEventListener("change", () => {
    setTimeout(syncFromMain, 80);
  });

  console.log("[personalizado] floating-preview listo ✅");
})();
